import React from 'react'
import './Home.css'

const Home = () => {
  return (
    <div className="home">
        <img className="home__img" src="https://i.ibb.co/dkvWn4r/Home-banner.png" alt="Home Banner"/>
        <img className="home__img__mobile" src="https://i.ibb.co/kc6f0RJ/Home-mobile-banner.png" alt="Home Banner"/>
    </div>
  )
}

export default Home;